import React, {Component} from 'react';
import {Route, Switch} from 'react-router-dom';
import {Row, Col} from 'reactstrap';

import axios from 'axios';

import PCourseProblemList from './CourseProblemListComponent.js';
import PProblemDetails from './ProblemDetailsComponent';
import PSideNavbar from './SideNavbarComponent';
import CourseHomePageBreadcrumb from '../breadcrumbs/CourseHomePageBreadcrumb';
import CourseSubmissions from './CourseSubmissionComponent.js';
import CourseRequestedSubmissions from './CourseRequestedSubmissionsComponent.js';
import TopicEditPage from './TopicEditPageComponent';
import CourseEditorPage from './CourseEditorPageComponent';
import AddOrUpdateProblem from './AddOrUpdateProblem.js'
import MarkdownRender from "../MarkdownRendererComponent";

//Data
import {serverPath} from "../common";

//Style
import '../../css/coursedetails.css';
import '../../css/common.css';

// Route: /p/course/:courseId
class PCourseHomePage extends Component {
	constructor(props) {
		super(props);

		this.state = {
			user: null,
			classes: [],
			tests: [],
			exams: [],
			courseInfo: {
				name: "",
				shortDescription: "",
			},
			lastSubmissions: [],
			allowedAccess: false
		};
	 }

    /**
	 * @description Fetching data from server.
     */
	getData() {
		if(this.state.user === null) {
            return;
        }

		axios.get(serverPath + 'professorService.php', {
				params: {
					action : 'getCourseData',
					courseId: this.props.match.params.courseId,
					professorId: this.state.user.userId
				}
			}).then((response)=> {
				if(response) {
                    this.setState({
                        classes: response.data.classes,
                        tests: response.data.tests,
                        exams: response.data.exams,
                        courseInfo : {
                            name : response.data.name,
                            shortDescription : response.data.descr,
                            courseId : this.props.match.params.courseId
                        },
						allowedAccess: true
                    });
				}
			});
	}

	/**
	 * @description User authentication.
	 **/
    componentDidMount() {
		axios.get(serverPath + "authService.php", {
			params: {
				action: 'whoIsLoggedIn'
			}
		}).then((response) => {
			if(response.data !== null && response.data.roleName === "professor") {
				this.setState({user: response.data});
				this.getData();
			} else {
				this.props.history.push("/home");
			}
		});
    }

	/**
	 * @description Fetching data if props have changed
	 **/
	componentDidUpdate(prevState) {
		if(prevState.match.params.courseId !== this.props.match.params.courseId) {
			this.getData();
		}
	}


    /**
	 * @description Rendering course home page.
     */
	render() {
		const courseInfo = {
			name : this.state.courseInfo.name,
			idCourse : this.props.match.params.courseId
		};

        return(
			<React.Fragment>
				<Row className ='row-eq-height' >
					<Col xs='3'>
						<PSideNavbar
							classes = {this.state.classes}
							tests = {this.state.tests}
							exams = {this.state.exams}
							courseInfo ={courseInfo}
								/>
					</Col>

					<Col xs='9' className='mt-5 mb-5'>
						<Row>
                            {	this.state.allowedAccess ?
								<Col xs='10' className='offset-1'>
                                    {
                                        this.props.match.isExact &&
                                        <React.Fragment>
                                            <Row>
                                                <Col>
                                                    <CourseHomePageBreadcrumb
                                                        courseName={this.state.courseInfo.name}/>
                                                </Col>
                                            </Row>
                                            <Row className='mt-2'>
                                                <Col className='card'>
                                                    <MarkdownRender source={this.state.courseInfo.shortDescription}/>
                                                </Col>
                                            </Row>
                                        </React.Fragment>
                                    }
                                    <Switch>
                                        <Route exact path={this.props.match.path + '/topic/:topicId'}
                                               component={PCourseProblemList}/>
                                        <Route path={this.props.match.path + '/topic/:topicId/problem/new'}
                                               component={AddOrUpdateProblem}/>
                                        <Route path={this.props.match.path + '/topic/:topicId/problem/:problemId/edit'}
                                               component={AddOrUpdateProblem}/>
                                        <Route path={this.props.match.path + '/topic/:topicId/problem/:problemId'}
                                               component={PProblemDetails}/>
                                        <Route path={this.props.match.path + '/submissions/all'}
                                               component={CourseSubmissions}/>
                                        <Route path={this.props.match.path + '/submissions/requested'}
                                               component={CourseRequestedSubmissions}/>
                                        <Route path={this.props.match.path + '/topic/:topicId/edit'}
                                               render={(props) => <TopicEditPage {...props}/>}/>
                                        <Route path={this.props.match.path + '/edit'}
                                               render={(props) => <CourseEditorPage {...props}/>}/>
                                    </Switch>
                                </Col>
								:
								<Col>
									<h2 style={{textAlign:'center'}}> Niste dodati kao nastavnik na izabranom kursu. </h2>
								</Col>
                            }
						</Row>
					</Col>
				</Row>
			</React.Fragment>
        );
    }
}

export default PCourseHomePage;
